import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  PiBuildingsFill,
  PiBankFill,
  PiShoppingCartFill,
} from "react-icons/pi";
import { LuPlus } from "react-icons/lu";
import FinIinfo from "../../assests/financial-info-icon.png";
import vector from "../../assests/Knowmore.svg";

import "../../../src/TextFamily.css";
import "./DeshBoard.css";
import { Api } from "../../services/httpService";
import { lowerCase } from "lodash";
import { IoIosArrowForward } from "react-icons/io";

import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Loader from "./LoaderModal";
import StatusModal from "./StatusModal";
function SidebarNavigation(props) {
  const merchantId = localStorage.getItem("_id");
  const [activeTab, setActiveTab] = useState(() => {
    const saved = localStorage.getItem("activeSidebarTab");
    return saved ? Number(saved) : 1;
  });
  const [activeNavigation, setActiveNavigation] = useState(false);
  const [companyInfoStatus, setCompanyInfoStatus] = useState(null);
  const [bankStatus, setBankStatus] = useState(null);
  const [finInfoStatus, setFinInfoStatus] = useState(null);
  const [selectProductStatus, setSelectProductStatus] = useState(null);
  const [completedSteps, setCompletedSteps] = useState(0);
  const [totalSteps, setTotalSteps] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statusModal, setStatusModal] = useState(false);

  let progressPercent =
    completedSteps && totalSteps
      ? Math.round((completedSteps / totalSteps) * 100)
      : 0;

  const fetchCompanies = async () => {
    try {
      const response = await Api("get", `/company/companyList/${merchantId}`);

      if (response && response.body.length > 0) {
        setActiveNavigation(true);
      }
      if (response.body === null || response.body.length === 0) {
        setCompanyInfoStatus("Not Started");
        setBankStatus("Not Started");
        setFinInfoStatus("Not Started");
        setSelectProductStatus("Not Started");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    localStorage.setItem("activeSidebarTab", activeTab);
  }, [activeTab]);

  const fetchProgress = async () => {
    try {
      setLoading(true);
      const response = await Api(
        `get`,
        `/company/dashboard/progress/${merchantId}`
      );
      if (response.success && response.body) {
        response?.body?.steps?.map((step) => {
          if (step.stepName === "Company Information") {
            if (step.status === null) {
              setCompanyInfoStatus("Not Started");
              return;
            }
            setCompanyInfoStatus(
              step.status.charAt(0).toUpperCase() +
                lowerCase(step.status).slice(1)
            );
          } else if (step.stepName === "Bank Details") {
            if (step.status === null) {
              setBankStatus("Not Started");
              return;
            }
            setBankStatus(
              step.status.charAt(0).toUpperCase() +
                lowerCase(step.status).slice(1)
            );
          } else if (step.stepName === "Financial Information") {
            if (step.status === null) {
              setFinInfoStatus("Not Started");
              return;
            }
            setFinInfoStatus(
              step.status.charAt(0).toUpperCase() +
                lowerCase(step.status).slice(1)
            );
          } else if (step.stepName === "Select Product") {
            if (step.status === null) {
              setSelectProductStatus("Not Started");
              return;
            }
            setSelectProductStatus(
              step.status.charAt(0).toUpperCase() +
                lowerCase(step.status).slice(1)
            );
          }
        });
      }
      if (
        response?.body?.completedSteps ||
        response?.body?.completedSteps === 0
      ) {
        setCompletedSteps(response?.body.completedSteps);
      }
      if (response?.body?.totalSteps) {
        setTotalSteps(response?.body?.totalSteps);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Add the classes here -> Designer Reference
  const getStatusClass = (status) => {
    if (!status) return "";
    if (status.toLowerCase() === "submitted") return "text-success";
    if (status.toLowerCase() === "in progress") return "text-primary";
    if (status.toLowerCase() === "not started") return "text-muted";
    if (status.toLowerCase() === "under review") return "text-muted";
    if (status.toLowerCase() === "approved") return "text-success";
    if (status.toLowerCase() === "rejected") return "";
    if (status.toLowerCase() === null) return "text-muted";
    return "";
  };

  useEffect(() => {
    if (merchantId) {
      fetchProgress();
      fetchCompanies();
    }
  }, [props?.progressRefreshKey]);

  const capitalizeWords = (str) =>
    str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";

  // A tab opens from anywhere on its row, not only from the arrow. The row hands the click to the tab's own link, so the same
  // navigation and the same rule apply (the tabs after the first stay shut until a company exists). A click that is already on
  // the link is left alone, or the tab would open twice.
  const openTabFromRow = (event) => {
    if (event.target.closest("a")) return;
    event.currentTarget.querySelector("a")?.click();
  };
  const rowProps = (canOpen) => ({
    onClick: openTabFromRow,
    style: { cursor: canOpen ? "pointer" : "default" },
  });

  return (
    <div>
      <div className="navigation-sidebar position-relative">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="getstart-section d-flex justify-content-between flex-wrap">
              <div className="start-section">
                <h1>Get Started</h1>
                <p>You're just 4 steps away from accessing your credit line.</p>
              </div>
              <div className="stage-complete">
                <div className="stage-box">
                  <CircularProgressbarWithChildren
                    value={progressPercent}
                    strokeWidth={5}
                    styles={buildStyles({
                      textColor: "black",
                      pathColor: "#0B84FE",
                      trailColor: "#d6d6d6",
                      pathTransition: "stroke-dashoffset 0.5s ease 0s",
                    })}
                  >
                    <p style={{ color: "black" }}>
                      {completedSteps} of {totalSteps}
                    </p>
                    <span style={{ color: "black" }}>Submitted</span>
                  </CircularProgressbarWithChildren>
                </div>
              </div>
            </div>
            <div
              className={`company-detail ${
                activeNavigation ? "navigation-active" : ""
              }`}
            >
              <ul className="p-0 m-0">
                {/* tab 1 */}
                <li className={activeTab === 1 ? "active" : ""}>
                  <div className="c-detail-box d-flex align-items-center flex-wrap py-4" {...rowProps(true)}>
                    <div className="icon-box me-3">
                      <PiBuildingsFill />
                    </div>
                    <div className="c-detail-title">
                      <p className="m-0">Company Information</p>
                      <span
                        className={getStatusClass(companyInfoStatus)}
                        style={
                          companyInfoStatus &&
                          companyInfoStatus.toLowerCase().replace(/_/g, " ") ===
                            "rejected"
                            ? { fontSize: "16px", color: "#B22D2D" }
                            : {}
                        }
                      >
                        {capitalizeWords(companyInfoStatus)}
                      </span>
                    </div>
                    <div className="c-detail-start ms-auto">
                      <Link
                        to=""
                        className="d-flex align-items-center"
                        onClick={() => setActiveTab(1)}
                      >
                        {companyInfoStatus &&
                        (companyInfoStatus.trim().toLowerCase() ===
                          "submitted" ||
                          companyInfoStatus.trim().toLowerCase() ===
                            "in progress" ||
                          companyInfoStatus.trim().toLowerCase() ===
                            "under review" ||
                          companyInfoStatus.trim().toLowerCase() ===
                            "approved" ||
                          companyInfoStatus.trim().toLowerCase() ===
                            "rejected" ||
                          companyInfoStatus.trim().toLowerCase() ===
                            "needs attention") ? (
                          <IoIosArrowForward fill="#000" /> // Add Styling For Arrow button :- Designer Reference
                        ) : (
                          <>
                            {activeTab === 1 ? (
                              <IoIosArrowForward fill="#000" />
                            ) : (
                              <>
                                Start{" "}
                                <span>
                                  <LuPlus fill="#0253A5" />
                                </span>
                              </>
                            )}
                          </>
                        )}
                      </Link>
                    </div>
                  </div>
                </li>
                {/* tab 2 */}
                <li className={activeTab === 2 ? "active" : ""}>
                  <div className="c-detail-box d-flex align-items-center flex-wrap py-4" {...rowProps(activeNavigation)}>
                    <div className="icon-box me-3">
                      <PiBankFill />
                    </div>
                    <div className="c-detail-title">
                      <p className="m-0">Bank Details</p>
                      <span
                        style={
                          bankStatus &&
                          bankStatus.toLowerCase().replace(/_/g, " ") ===
                            "rejected"
                            ? { fontSize: "16px", color: "#B22D2D" }
                            : {}
                        }
                        className={getStatusClass(bankStatus)}
                      >
                        {capitalizeWords(bankStatus)}
                      </span>
                    </div>
                    <div className="c-detail-start ms-auto">
                      <Link
                        to="bank-details"
                        className="d-flex align-items-center"
                        onClick={(e) =>
                          activeNavigation
                            ? setActiveTab(2)
                            : e.preventDefault()
                        }
                      >
                        {bankStatus &&
                        (bankStatus.trim().toLowerCase() === "submitted" ||
                          bankStatus.trim().toLowerCase() === "in progress" ||
                          bankStatus.trim().toLowerCase() === "under review" ||
                          bankStatus.trim().toLowerCase() === "approved" ||
                          bankStatus.trim().toLowerCase() === "rejected" ||
                          bankStatus.trim().toLowerCase() ===
                            "needs attention") ? (
                          <IoIosArrowForward fill="#000" />
                        ) : (
                          <>
                            {activeTab === 2 ? (
                              <IoIosArrowForward fill="#000" />
                            ) : (
                              <>
                                Start{" "}
                                <span>
                                  <LuPlus fill="#0253A5" />
                                </span>
                              </>
                            )}
                          </>
                        )}
                      </Link>
                    </div>
                  </div>
                </li>
                {/* tab 3 */}
                <li className={activeTab === 3 ? "active" : ""}>
                  <div className="c-detail-box d-flex align-items-center flex-wrap py-4" {...rowProps(activeNavigation)}>
                    <div className="icon-box me-3">
                      <img
                        src={FinIinfo}
                        style={{ width: 22 }}
                        alt="Financial Info"
                      />
                    </div>
                    <div className="c-detail-title">
                      <p className="m-0">Financial Information</p>
                      <span
                        style={
                          finInfoStatus &&
                          finInfoStatus.toLowerCase().replace(/_/g, " ") ===
                            "rejected"
                            ? { fontSize: "16px", color: "#B22D2D" }
                            : {}
                        }
                        className={getStatusClass(finInfoStatus)}
                      >
                        {capitalizeWords(finInfoStatus)}
                      </span>
                    </div>
                    <div className="c-detail-start ms-auto">
                      <Link
                        to="financial-info"
                        className="d-flex align-items-center"
                        onClick={(e) =>
                          activeNavigation
                            ? setActiveTab(3)
                            : e.preventDefault()
                        }
                      >
                        {finInfoStatus &&
                        (finInfoStatus.trim().toLowerCase() === "submitted" ||
                          finInfoStatus.trim().toLowerCase() ===
                            "in progress" ||
                          finInfoStatus.trim().toLowerCase() ===
                            "under review" ||
                          finInfoStatus.trim().toLowerCase() === "approved" ||
                          finInfoStatus.trim().toLowerCase() === "rejected" ||
                          finInfoStatus.trim().toLowerCase() ===
                            "needs attention") ? (
                          <IoIosArrowForward fill="#000" />
                        ) : (
                          <>
                            {activeTab === 3 ? (
                              <IoIosArrowForward fill="#000" />
                            ) : (
                              <>
                                Start{" "}
                                <span>
                                  <LuPlus fill="#0253A5" />
                                </span>
                              </>
                            )}
                          </>
                        )}
                      </Link>
                    </div>
                  </div>
                </li>
                {/* tab 4 */}
                <li className={activeTab === 4 ? "active" : ""}>
                  <div className="c-detail-box d-flex align-items-center flex-wrap py-4" {...rowProps(activeNavigation)}>
                    <div className="icon-box me-3">
                      <PiShoppingCartFill />
                    </div>
                    <div className="c-detail-title">
                      <p className="m-0">Select Product</p>
                      <span
                        style={
                          selectProductStatus &&
                          selectProductStatus
                            .toLowerCase()
                            .replace(/_/g, " ") === "rejected"
                            ? { fontSize: "16px", color: "#B22D2D" }
                            : {}
                        }
                        className={getStatusClass(selectProductStatus)}
                      >
                        {capitalizeWords(selectProductStatus)}
                      </span>
                    </div>
                    <div className="c-detail-start ms-auto">
                      <Link
                        to="select-product"
                        className="d-flex align-items-center"
                        onClick={(e) =>
                          activeNavigation
                            ? setActiveTab(4)
                            : e.preventDefault()
                        }
                      >
                        {selectProductStatus &&
                        (selectProductStatus.trim().toLowerCase() ===
                          "submitted" ||
                          selectProductStatus.trim().toLowerCase() ===
                            "in progress" ||
                          selectProductStatus.trim().toLowerCase() ===
                            "under review" ||
                          selectProductStatus.trim().toLowerCase() ===
                            "approved" ||
                          selectProductStatus.trim().toLowerCase() ===
                            "rejected" ||
                          selectProductStatus.trim().toLowerCase() ===
                            "needs attention") ? (
                          <IoIosArrowForward fill="#000" />
                        ) : (
                          <>
                            {activeTab === 4 ? (
                              <IoIosArrowForward fill="#000" />
                            ) : (
                              <>
                                Start{" "}
                                <span>
                                  <LuPlus fill="#0253A5" />
                                </span>
                              </>
                            )}
                          </>
                        )}
                      </Link>
                    </div>
                  </div>
                </li>
              </ul>
              <button
                className="d-flex align-items-center justify-content-end  mt-2"
                onClick={() => setStatusModal(true)}
                style={{ position: "absolute", bottom: "3%", right: "5%" }}
              >
                <img
                  src={vector}
                  alt="Know more"
                  style={{ marginRight: "5px" }}
                  height={24}
                  width={24}
                />
                <p
                  className="m-0"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#0B84FE",
                  }}
                >
                  Know more
                </p>
              </button>
            </div>
          </>
        )}
      </div>
      {statusModal && (
        <StatusModal
          onHide={() => setStatusModal(false)}
          statusModal={statusModal}
        />
      )}
    </div>
  );
}

export default SidebarNavigation;
